function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10 14.5a4.5 4.5 0 110-9 4.5 4.5 0 010 9z",
  stroke: "#DEBB00"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10 12.5a2.5 2.5 0 110-5 2.5 2.5 0 010 5z",
  fill: "#DEBB00",
  stroke: "#DEBB00"
});

var SvgIconCircleYellow = function SvgIconCircleYellow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwIDE0LjVDNy41MTQ2NCAxNC41IDUuNSAxMi40ODU0IDUuNSAxMEM1LjUgNy41MTQ2NCA3LjUxNDY0IDUuNSAxMCA1LjVDMTIuNDg1NCA1LjUgMTQuNSA3LjUxNDY0IDE0LjUgMTBDMTQuNSAxMi40ODU0IDEyLjQ4NTQgMTQuNSAxMCAxNC41WiIgc3Ryb2tlPSIjREVCQjAwIi8+CjxwYXRoIGQ9Ik0xMCAxMi41QzguNjE5MjQgMTIuNSA3LjUgMTEuMzgwOCA3LjUgMTBDNy41IDguNjE5MjQgOC42MTkyNCA3LjUgMTAgNy41QzExLjM4MDggNy41IDEyLjUgOC42MTkyNCAxMi41IDEwQzEyLjUgMTEuMzgwOCAxMS4zODA4IDEyLjUgMTAgMTIuNVoiIGZpbGw9IiNERUJCMDAiIHN0cm9rZT0iI0RFQkIwMCIvPgo8L3N2Zz4K";
export { SvgIconCircleYellow as ReactComponent };